/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { reverse } from "../assets/reverse";
import { Icon, type IconBaseProps } from "../icon";

export const IconReverse = (props: IconBaseProps) => <Icon {...props} svg={reverse} />;

IconReverse.displayName = "IconReverse";
